import React, { useCallback, useEffect, useMemo, useState } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Link, useNavigate } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import {
    uploadVendorExcel,
    loggedInUserUrls,
    activeDeactiveVendor,
    getWarehouseKeyValueList, //sync
    getOrgKeyValue,
} from '../../../services/index';
import toast, { Toaster } from 'react-hot-toast';
import Cookies from 'universal-cookie';
import EditIcon from '@mui/icons-material/Edit';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import DownloadIcon from '@mui/icons-material/Download';
import UploadIcon from '@mui/icons-material/Upload';
import { BASE_URL_INVENTORY, DOWNLOAD_VENDOR_URL, VENDOR_URL } from '../../../CONSTANTS';
import PaginationDataTable from '../../Common/PaginationDataTable';
import Select from 'react-select';
import { getWarehouseKeyValueDetailsList, syncVendorWareHouse } from '../../../services/Settings/WarehouseService';
import SyncIcon from "@mui/icons-material/Sync";

const VendorList = () => {
    const [error, setError] = useState({});
    const [loading, setLoading] = useState(false);
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [show2, setShow2] = useState(false);
    const handleClose2 = () => setShow2(false);

    const [file1, setFile1] = useState({
        fileBase64: '',
        fileName: '',
    });
    const [wareOptions, setWareOptions] = useState([]);
    const [refreshFlag, setRefreshFlag] = useState(0);
    const [rows, setRows] = useState([]);
    const [org, setOrg] = useState({ value: '' });
    const [orgOptions, setOrgOptions] = useState([]);
    const [showSyncModal, setShowSyncModal] = useState(false);
    const [selectedFromWarehouse, setSelectedFromWarehouse] = useState(null);
    const [selectedToWarehouse, setSelectedToWarehouse] = useState(null);
    const [syncWareHouseOption, setSyncWareHouseOptions] = useState([]);
    let navigate = useNavigate();
    const orgDetail = JSON.parse(localStorage.getItem('orgDetail'));
    let userDetail = JSON.parse(localStorage.getItem("userDetail"));
    let userType = userDetail ? userDetail.userType : "";

    useEffect(() => {
        getWarehouseKeyValueList().then((res) => {
            if (res.errorCode === 0) {
                let data = res.responsePacket;
                const options = data.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWareOptions(options);
            }
        });
        if (orgOptions) {
            getOrgKeyValue().then((res) => {
                if (res.errorCode === 0) {
                    const options = res.responsePacket?.map((d) => ({
                        value: d.key,
                        label: d.value,
                    }));
                    setOrg(options[0]);
                    setOrgOptions(options);
                } else {
                    toast(res.message);
                }
            });
        }
    }, []);

    useEffect(() => {
        getWarehouseKeyValueDetailsList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setSyncWareHouseOptions(options);
                setSelectedFromWarehouse(options[0]);
                setSelectedToWarehouse(options[options.length - 1]);
            } else {
                toast(res);
            }
        });
    }, []);

    const handleRefresh = useCallback(() => {
        setRefreshFlag(refreshFlag + 1);
    }, [refreshFlag]);


    const handleCustomSelect = (e) => {
        navigate('/vendors/' + e);
    };

    const handleActiveInactive = (row) => {
        activeDeactiveVendor(row.recordId).then((res) => {
            if (res.errorCode === 0) {
                toast(res.message);
            } else {
                toast(res.message);
                return;
            }
        });
    };

    const handleOrgSelect = (e) => {
        setOrg(e);
        handleRefresh();
    }

    const columns = useMemo(() =>
        [
            {
                name: 'NAME',
                selector: (row) => row?.title,
                width: "300px"
            },
            {
                name: 'EMAIL',
                selector: (row) => row?.email,
            },
            {
                name: 'WORK PHONE',
                selector: (row) => row?.phone,
            },
            {
                name: 'ITEM PRICE LIST',
                selector: (row) => row?.itemPriceListTitle
            },
            {
                name: 'ORGANISATION TITLE',
                selector: (row) => row?.organisationTitle,
            },
            {
                name: 'ACTION',
                selector: (row) => (
                    <div>
                        <EditIcon
                            style={{ fontSize: '15px', cursor: 'pointer' }}
                            onClick={() => {
                                navigate('/vendors/' + row?.recordId + '/edit');
                            }}
                        />
                        &nbsp;&nbsp;
                        {row.active ? (
                            <CheckCircleIcon
                                style={{
                                    fontSize: '15px',
                                    cursor: 'pointer',
                                    color: 'greenyellow',
                                }}
                                onClick={() => handleActiveInactive(row)}
                            />
                        ) : (
                            <CancelIcon style={{ fontSize: '15px', cursor: 'pointer', color: 'tomato' }} onClick={() => handleActiveInactive(row)} />
                        )}
                    </div>
                ),
            },
        ],
        [handleRefresh]
    );

    const convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const handleFileRead = async (event) => {
        const file = event.target.files[0];
        const base64 = await convertBase64(file);
        const base = base64.split(',')[1];
        setFile1({
            fileBase64: base,
            fileName: file.name,
        });
    };

    const handleUpload = () => {
        uploadVendorExcel(file1).then((res) => {
            if (res.errorCode === 0) {
                // vendorAllRecords();
                toast(res.message);
            } else {
                setError(res);
                setShow2(true);
            }
        });
        setTimeout(handleClose(), 6000);
    };

    const [userData, setUserData] = useState('');
    const [urlList, setUrlList] = useState('');
    const [userRights, setUserRights] = useState('');

    useEffect(() => {
        let loginData1 = new Cookies().get('loginData1');
        setUserData(new Cookies().get('loginData1'));
        let id = loginData1.recordId;

        loggedInUserUrls().then((res) => {
            if (res.errorCode === 0) {
                setUrlList(res.responsePacket.urlList);
                setUserRights(res.responsePacket);
            } else {
                toast.error(res.message);
            }
        });
    }, []);

    const handleWarn = () => {
        alert('Access Denied!');
        return;
    };

    const handleSelectWarehouse = (e, type) => {
        if (type === "from") {
            setSelectedFromWarehouse(e);
        } else {
            setSelectedToWarehouse(e)
        }
    };

    const handleWareHouseSync = () => {
        const data = {
            fromWarehouseUUid: selectedFromWarehouse.value,
            toWarehouseUUid: selectedToWarehouse.value,
        }
        syncVendorWareHouse(data).then((res) => {
            if (res.errorCode == 0) {
                toast.success(res.message)
                setShowSyncModal(false)
            } else {
                toast.error(res.message)
                return;
            }
        }).catch(() => {
            toast.error("server error");
            return
        });
    }

    const filter = useMemo(() => ({ uuid: org?.value }), [org]);

    return (
        <>
            <Modal show={show2} onHide={handleClose2}>
                <Modal.Body>
                    <div> {error.message}</div>
                    <br />
                    {error.listOfErrors &&
                        error.listOfErrors?.map((item) => {
                            return <div>{item}</div>;
                        })}
                </Modal.Body>
            </Modal>

            <div className='fill list-header d-print-none'>
                <Modal show={show} onHide={handleClose} size='sm'>
                    <Modal.Body>
                        <input
                            autoComplete='off'
                            className='ember-text-field ember-view form-control '
                            id='originalFileName'
                            type='file'
                            inputProps={{
                                accept: 'image/*, .xlsx, .xls, .csv, .pdf, .pptx, .pptm, .ppt',
                            }}
                            required
                            label='Document'
                            name='originalFileName'
                            onChange={(e) => handleFileRead(e)}
                            size='small'
                            variant='standard'
                        />
                    </Modal.Body>

                    <Modal.Footer>
                        {userRights.adminRoleEnum === 'ROLE_SUPER_ADMIN' || (urlList && urlList.some((data) => data.url === '/vendor/downloadVendorExcel')) ? (
                            <a href={`${BASE_URL_INVENTORY}` + `${DOWNLOAD_VENDOR_URL}`} target='_blank' download>
                                <Button variant='primary'>
                                    <DownloadIcon />
                                    Download
                                </Button>
                            </a>
                        ) : (
                            <Button variant='secondary' onClick={handleWarn}>
                                <DownloadIcon /> Download
                            </Button>
                        )}

                        {userRights.adminRoleEnum === 'ROLE_SUPER_ADMIN' || (urlList && urlList.some((data) => data.url === '/vendor/uploadPriceExcel')) ? (
                            <Button variant='primary' onClick={handleUpload}>
                                <UploadIcon />
                                Upload
                            </Button>
                        ) : (
                            <Button variant='secondary' onClick={handleWarn}>
                                Upload
                            </Button>
                        )}
                    </Modal.Footer>
                </Modal>
            </div>

            <Modal show={showSyncModal} onHide={() => setShowSyncModal(false)} size="md" >
                <Modal.Body style={{ minHeight: "150px" }}>
                    <div className="d-flex mt-2">
                        <div className="d-flex align-items-center pl-3 mr-3">
                            <div className="mr-4">From Warehouse:</div>
                            <div style={{ minWidth: "200px" }}>
                                <Select
                                    value={selectedFromWarehouse}
                                    id="fromWarehouse"
                                    options={syncWareHouseOption}
                                    onChange={(e) => handleSelectWarehouse(e, "from")}
                                />
                            </div>
                        </div>
                        <div className="d-flex align-items-center pl-3">
                            <div className="mr-4"> To Warehouse:</div>
                            <div style={{ minWidth: "200px" }}>
                                <Select
                                    value={selectedToWarehouse}
                                    id="toWarehouse"
                                    options={syncWareHouseOption}
                                    onChange={(e) => handleSelectWarehouse(e, "to")}
                                />
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleWareHouseSync}>
                        Vendor  Sync
                    </Button>
                </Modal.Footer>
            </Modal>

            <div className='vendorlistDataTable' style={{ height: 500, width: '100%' }}>

                <div className="excel-postn mt-2">
                    <div className="d-flex align-items-center">
                        <Button variant='primary' onClick={handleShow} className='tooltip-container ember-view btn btn-primary d-flex align-items-center'>
                            <ImportExportIcon /> Excel
                        </Button>
                        <Link to='/vendors/new'>
                            <Button id='ember5839' className='tooltip-container ember-view btn btn-primary d-flex align-items-center' type='button'>
                                <AddIcon />
                                New
                            </Button>
                        </Link>
                        {userType === "ROLE_SUPER_ADMIN" && <div>
                            <Button variant="primary" onClick={() => setShowSyncModal(true)}>
                                <SyncIcon /> Sync
                            </Button>
                        </div>}
                    </div>
                </div>
                {orgDetail?.isDefault && <div className="purchase-warehouse mt-2">
                    <Select className='text-left' options={orgOptions} value={org} onChange={handleOrgSelect} />
                </div>}

                {org.value !== ""
                    && <PaginationDataTable
                        paginationUrl={VENDOR_URL() + "getAllRecords/"}
                        serverSidePagination={true}
                        search={true}
                        pagination={false}
                        className="position-relative"
                        columns={columns}
                        showNewBtn={true}
                        filter={filter}
                        onRowClicked={(data) => {
                            handleCustomSelect(data.recordId);
                        }}
                    />}
            </div>
            <Toaster />
        </>
    );
};

export default VendorList;
